import React from 'react';
import styles from './ActionRow.scss';
import { Button, BUTTON } from 'components/common/Button/Button';

export default (props) => (
    <div className={styles.actionRow} data-cy="ActionRow">
        <Button
            bgcolor={BUTTON.BGCOLOR.CLEAR}
            color={BUTTON.COLOR.BLACK}
            type={BUTTON.SIZE.SECONDARY}
            onClick={props.onCancel}
            data-cy="ActionRow-Cancel"
        >
            Cancel
        </Button>
        <Button
            bgcolor={BUTTON.BGCOLOR.ORANGE}
            color={BUTTON.COLOR.WHITE}
            onClick={props.onPrimaryAction}
            disabled={props.primaryActionDisabled}
            data-cy="ActionRow-primaryActionLabel"
        >
            {props.primaryActionLabel}
        </Button>
    </div>
);
